import { BFP_ROLES, CLIENT_ROLES } from '@/core';
import { isBFP } from '@/platform';
import { useMemo } from 'react';

export function useUserRoleValues(organizationId: string[] | undefined) {
  return useMemo(() => {
    if (organizationId && organizationId.length > 1) return CLIENT_ROLES;
    const bfp = isBFP(organizationId ? organizationId[0] : undefined);
    return bfp ? BFP_ROLES : CLIENT_ROLES;
  }, [organizationId]);
}
